import { render, staticRenderFns } from "./cpt-chart-map-gc.vue?vue&type=template&id=320b8264&scoped=true"
import script from "./cpt-chart-map-gc.vue?vue&type=script&lang=js"
export * from "./cpt-chart-map-gc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "320b8264",
  null
  
)

export default component.exports